import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import BigBanner from '../../components/BigBanner';
import { Button } from '../../components/Button';
import { PageHelmet } from '../../components/PageHelmet';
import FaleConoscoForm from './FaleConoscoForm';

export default function FaleConoscoPage(): ReactElement {
  return (
    <div className="h-full min-h-[calc(100vh-549px)]">
      <PageHelmet title="Fale Conosco | OdontoGroup" />

      <BigBanner
        href="#ouvidoria-form"
        page="ouvidoria"
        mainText={
          <div style={{ textAlign: 'justify' }}>
            Estamos aqui para cuidar do seu sorriso – e te ouvir com atenção.
            <br />
            <span
              style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }}
            >
              Em caso de dúvidas, sugestões ou necessidade de ajuda com o seu
              plano, fale com a gente. Nosso time está pronto para te atender
              com presteza e agilidade.
            </span>
          </div>
        }
      />

      <section className="bg-primary-main text-white px-4 py-16 flex flex-col items-center text-center">
        <div className="max-w-4xl">
          <p className="text-2xl md:text-3xl leading-9 font-light mb-10">
            Agora você, nosso <strong>beneficiário</strong> ou{' '}
            <strong>parceiro</strong>, pode registrar seu “Fale Conosco”
            acessando sua área exclusiva em nosso site.
          </p>

          <p className="text-lg font-light mb-8">
            Clique no botão abaixo que o identifique e entre em contato com a
            nossa equipe:
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=1"
            text="Pessoa Física"
            className="w-fit"
            intent="newOrange"
          />
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=2"
            text="Pessoa Jurídica"
            className="w-fit"
            intent="newOrange"
          />
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=6"
            text="Corretor"
            className="w-fit"
            intent="newOrange"
          />
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=4"
            text="Prestador"
            className="w-fit"
            intent="newOrange"
          />
        </div>

        <div className="max-w-3xl">
          <p className="text-lg font-light mb-6">
            Você também pode entrar em contato preenchendo o formulário abaixo.
          </p>
        </div>

        <div className="bg-white text-primary-main rounded shadow-card p-8 w-full max-w-[760px] text-left">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Registrar um Fale Conosco
          </h3>
          <FaleConoscoForm />
        </div>
      </section>

      <section className="bg-primary-main px-6 py-12 text-white text-center flex flex-col items-center">
        <p className="text-2xl md:text-3xl leading-9 font-light max-w-4xl mb-6">
          Ou através do nosso aplicativo. Baixe aqui:
        </p>

        <div className="flex flex-wrap justify-center gap-8 mt-4">
          <a
            className="max-w-[160px]"
            href={process.env.REACT_APP_GOOGLE_PLAY}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/assets/images/google-play-tag.png"
              alt="Google Play"
              className="w-full"
            />
          </a>
          <a
            className="max-w-[160px]"
            href={process.env.REACT_APP_APPLE_STORE}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/assets/images/app-store-tag.png"
              alt="App Store"
              className="w-full"
            />
          </a>
        </div>
      </section>
    </div>
  );
}
